import { FETCH_STORE_EMPLOYEES } from "../constants/endpoints";
import axiosClient from "./axios";

class storeEmployees {
  static async fetchStoreEmployees(shopId: string) {
    const response = await axiosClient.post(
      FETCH_STORE_EMPLOYEES.replace("{shopId}", shopId)
    );
    return response;
  }
}

export default storeEmployees;
